"use client";

import dynamic from 'next/dynamic';

import React, { useEffect } from "react";
const LogoLoading = dynamic(() => import('@/components/ui/LogoLoading'));
import logWithTimestamp from "@/utils/refactored/helpers";

const LoadingTransparent = () => {
  return (
    <div className="fixed inset-0 z-[999999] flex flex-col items-center justify-center h-screen backdrop-blur-sm">
      <LogoLoading />
    </div>
  );
};

export default LoadingTransparent;
